// @flow
import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import moment from 'moment';
import { withStyles, Button } from '@material-ui/core';
import theme from './index.theme';
import {
  getDisplayCopyright,
  getHelpButtonLinkUri,
} from '../../reducers/portalConfig';
import { isEmpty } from "lodash";

const copyrightText = "Broadcom. All Rights Reserved. The term 'Broadcom' refers to Broadcom Inc. and/or its subsidiaries.";
const Footer = ({
  classes = {},
  displayCopyright = true,
  helpButtonLinkUri,
}: Object) => (
  <div className={classes.Footer}>
    <div>
      {displayCopyright &&
        <div
          data-apim-test="copyright"
        >
          {`© ${moment().format('YYYY')} `}
          {copyrightText}
        </div>
      }
    </div>
    {!isEmpty(helpButtonLinkUri) &&
      <Button
        data-apim-test="footer-help-button"
        variant="contained"
        color="secondary"
        className={classes.FooterHelpButton}
        href={helpButtonLinkUri}
      >
        Help
      </Button>
    }
  </div>
);

export const mapStateToProps = (state: Object) => ({
  displayCopyright: getDisplayCopyright(state),
  helpButtonLinkUri: getHelpButtonLinkUri(state),
});

export default compose(
  withStyles(theme),
  connect(mapStateToProps),
)(Footer);
